import { Link } from "react-router-dom";
import { btn } from "./buttonStyles";

// The portal's one button. Anything that looks like a button should be this,
// or should wear `btn(...)` from ./buttonStyles, so weight, radius and colour
// are decided in a single place. See that file for what each variant means.
const Button = ({
  children,
  variant = "primary",
  size = "md",
  icon: Icon,
  to,
  href,
  className = "",
  ...props
}) => {
  const classes = btn(variant, size, className);

  const inner = (
    <>
      {Icon && <Icon size={size === "sm" ? 13 : 15} strokeWidth={2} className="shrink-0" />}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {inner}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {inner}
      </a>
    );
  }

  return (
    <button className={classes} {...props}>
      {inner}
    </button>
  );
};

export default Button;
